export const TAB_SELECTOR_LAYOUT = {
    SIDEBAR: 'sidebar',
    TAB_ROW: 'tabRow',
} as const;
